export const CreateClientsRole = 'CreateClients';
export const CreateContractAmendmentRole = 'CreateContractAmendment';
export const CreateFinancialFeedRole = 'CreateFinancialFeed';
export const CreateFundingPoolRole = 'CreateFundingPool';
export const CreateMonthlyCloseRole = 'CreateMonthlyClose';
export const CreateNonFinancialFeedRole = 'CreateNonFinancialFeed';
export const CreateNoteRole = 'CreateNote';
export const CreatePhotoRole = 'CreatePhoto';
export const CreateLookupsRole = 'CreateLookups';
export const DeleteMonthlyCloseRole = 'DeleteMonthlyClose';
export const DeleteNoteRole = 'DeleteNote';
export const DeletePhotoRole = 'DeletePhoto';
export const ReadAccessRole = 'ReadAccess';
export const UpdateClientRole = 'UpdateClient';
export const UpdateContractRole = 'UpdateContract';
export const UpdatePropertyRole = 'UpdateProperty';

const AvailableRoles = [
  CreateClientsRole,
  CreateContractAmendmentRole,
  CreateFinancialFeedRole,
  CreateFundingPoolRole,
  CreateMonthlyCloseRole,
  CreateNonFinancialFeedRole,
  CreateNoteRole,
  CreatePhotoRole,
  CreateLookupsRole,
  DeleteMonthlyCloseRole,
  DeleteNoteRole,
  DeletePhotoRole,
  ReadAccessRole,
  UpdateClientRole,
  UpdateContractRole,
  UpdatePropertyRole,
];

export default AvailableRoles;
